import './BussinessPage.css';

function BussinessPage(){
  const sections = [
    {
      title: '食品製造機械の整備・メンテナンス',
      image: '/images/business-01.jpg',
      lead: [
        'かまぼこをはじめとした水産加工食品・食品工場向け機械の',
        '点検・整備・修理・調整を行っています。',
        '長年使用されてきた機械は、わずかなズレや摩耗が',
        '製品品質や歩留まりに大きく影響します。',
      ],
      points: [
        '刃物・カッター部の調整',
        '成形精度の回復',
        '異音・振動の原因特定',
        '食品機械特有の衛生面を考慮した整備',
      ],
      note: '現場に合わせた確実な整備を行います。',
    },
    {
      title: 'コンベア設備の整備・改修',
      image: '/images/business-02.JPG',
      lead: [
        '食品工場の要となるコンベア設備。',
        '搬送不良や停止トラブルは、生産ライン全体の',
        '大きなロスにつながります。',
      ],
      points: [
        'ベルト交換・蛇行修正',
        '駆動部・モーター点検',
        'ステンレスフレーム補修',
        'レイアウト変更・高さ変更',
      ],
      note: '既存設備を活かした改善提案も可能です。',
    },
    {
      title: 'ボイル・加熱設備の点検整備',
      image: '/images/business-03.JPG',
      lead: [
        'ボイル機・加熱ラインは、',
        '温度管理・安全性・安定稼働が重要です。',
      ],
      points: [
        '加熱ムラ',
        '温度が安定しない',
        '蒸気漏れ',
        'バルブの固着',
      ],
      note: '定期点検・部品交換・調整整備を行います。',
    },
    {
      title: '型作成機・成形関連装置の整備',
      image: '/images/business-04.JPG',
      lead: [
        '成形精度は、製品の見た目と品質を左右します。',
      ],
      points: [
        '成形型の調整',
        '駆動部の摩耗修正',
        'ベルト・ガイド交換',
        '成形寸法の再調整',
      ],
      note: '「元の精度に戻す」整備を得意としています。',
    },
    {
      title: '熱交換機・配管設備・その他機械整備',
      image: '/images/business-05.jpg',
      lead: [
        '食品工場には、さまざまな設備が存在します。',
        'メーカー対応が終了した機械や、',
        '図面が残っていない設備でも対応可能です。',
      ],
      points: [
        '熱交換機',
        'ポンプユニット',
        '配管設備',
        '圧力タンク',
        '古くなった専用機',
      ],
      note: ['「どこに頼めばいいか分からない」', 'そんな時こそ、ぜひご相談ください。'],
    },
  ];

  return (
    <div className="BussinessPage">
      <div className="business-hero">
        <span className="business-hero-title">事業紹介</span>
      </div>

      <div className="business-sections">
        {sections.map((section) => (
          <div className="business-section" key={section.title}>
            <div className="business-image">
              <img src={section.image} alt={section.title} />
            </div>
            <div className="business-text">
              <h3>{section.title}</h3>
              <div className="business-lead">
                {section.lead.map((line) => (
                  <p key={line}>{line}</p>
                ))}
              </div>
              <ul>
                {section.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
              <p className="business-note">
                {Array.isArray(section.note)
                  ? section.note.map((line, lineIndex) => (
                      <span key={`${section.title}-note-${lineIndex}`}>
                        {line}
                        {lineIndex < section.note.length - 1 && <br />}
                      </span>
                    ))
                  : section.note}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BussinessPage;
